import { useEffect } from "react";

/**
 * Lightweight SEO helper — sets document.title, description, canonical, og:*.
 * No React-helmet dependency needed.
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = "https://images.unsplash.com/photo-1630797160666-38e8c5ba44c1?w=1200",
  type = "website",
  jsonLd,
}) {
  useEffect(() => {
    const site = "CreatorMic Pro";
    const fullTitle = title ? `${title} | ${site}` : `${site} — Professional Wireless Audio for Every Creator`;
    document.title = fullTitle;

    const upsert = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attrs.tag || "meta");
        document.head.appendChild(el);
      }
      Object.entries(attrs).forEach(([k, v]) => {
        if (k === "tag") return;
        el.setAttribute(k, v);
      });
      return el;
    };

    upsert('meta[name="description"]', { name: "description", content: description || "Professional wireless microphones, USB-C mics, and mobile audio gear for TikTok creators, YouTubers, and podcasters." });
    upsert('link[rel="canonical"]', { tag: "link", rel: "canonical", href: `https://creatormicpro.com${path}` });
    upsert('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsert('meta[property="og:description"]', { property: "og:description", content: description || "Professional wireless audio for every creator." });
    upsert('meta[property="og:type"]', { property: "og:type", content: type });
    upsert('meta[property="og:url"]', { property: "og:url", content: `https://creatormicpro.com${path}` });
    upsert('meta[property="og:image"]', { property: "og:image", content: image });
    upsert('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsert('meta[name="twitter:image"]', { name: "twitter:image", content: image });

    // JSON-LD
    document.querySelectorAll('script[data-cmp-jsonld="true"]').forEach((s) => s.remove());
    if (jsonLd) {
      const arr = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      arr.forEach((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-cmp-jsonld", "true");
        s.textContent = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
  }, [title, description, path, image, type, jsonLd]);

  return null;
}
